(() => {
  'use strict';
  const tag = 'wb-frame-colour-options';
  if (customElements.get(tag)) return;
  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.form = this.closest('form');
      this.inputs = [...this.querySelectorAll('[data-frame-colour]')];
      if (!this.form || !this.inputs.length) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.inputs.forEach(input => input.addEventListener('change', () => this.refresh(), options));
      this.form.addEventListener('invalid', event => {
        if (this.inputs.includes(event.target)) this.showError(true);
      }, { ...options, capture: true });
      // Capture runs before the product page's AJAX submit handler.
      this.form.addEventListener('submit', event => {
        if (this.selected()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.showError(true);
        this.inputs[0].focus();
        this.inputs[0].reportValidity();
      }, { ...options, capture: true });
      // Native radios already serialize; set ensures exactly one value, and
      // records the finish alongside the existing private production layout.
      this.form.addEventListener('formdata', event => {
        const choice = this.selected();
        if (!choice) return;
        event.formData.set('properties[Frame colour]', choice.value);
        const key = 'properties[_Definition layout]';
        const raw = event.formData.get(key);
        if (typeof raw !== 'string') return;
        try {
          const layout = JSON.parse(raw);
          if (layout && typeof layout === 'object' && !Array.isArray(layout)) {
            layout.frameColour = choice.value;
            event.formData.set(key, JSON.stringify(layout));
          }
        } catch (_) { /* Preserve existing production data if it is not JSON. */ }
      }, options);
      this.form.addEventListener('reset', () => queueMicrotask(() => this.refresh()), options);
      this.refresh();
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
    selected() { return this.inputs.find(input => input.checked && !input.disabled && input.value); }
    showError(visible) {
      const error = this.querySelector('[data-frame-error]');
      if (error) error.hidden = !visible;
      this.inputs.forEach(input => input.setAttribute('aria-invalid', String(visible)));
    }
    refresh() {
      const choice = this.selected();
      const label = this.querySelector('[data-frame-selected]');
      if (label) label.textContent = choice ? choice.value : 'Please choose a frame colour';
      this.showError(false);
    }
  });
})();
